export const qualityPresets = {
    'RSA - 4800nar / 4500 min': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 13' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '4800', min_max_or_rejection_value: 'Min 4500' },
        '4': { typical_or_guaranteed_value: '25', min_max_or_rejection_value: 'Max 30' },
        '5': { typical_or_guaranteed_value: '21 - 24', min_max_or_rejection_value: 'Min 18' },
        '6': { typical_or_guaranteed_value: '0.8', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'RSA - 4800nar / 4600 min': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 13' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '4800', min_max_or_rejection_value: 'Min 4600' },
        '4': { typical_or_guaranteed_value: '25', min_max_or_rejection_value: 'Max 29' },
        '5': { typical_or_guaranteed_value: '21 - 24', min_max_or_rejection_value: 'Min 18' },
        '6': { typical_or_guaranteed_value: '0.8', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'RSA - 5500nar (RB3)': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 14' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '5500', min_max_or_rejection_value: 'Min 5200' },
        '4': { typical_or_guaranteed_value: '16 - 20', min_max_or_rejection_value: 'Max 23' },
        '5': { typical_or_guaranteed_value: '23 - 28', min_max_or_rejection_value: 'Min 20' },
        '6': { typical_or_guaranteed_value: '0.8', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: 'Min 1150', min_max_or_rejection_value: '-' }
      }
    },
    'RSA - 6000nar (RB1)': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 12' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '6000', min_max_or_rejection_value: 'Min 5850' },
        '4': { typical_or_guaranteed_value: '12 - 14', min_max_or_rejection_value: 'Max 15' },
        '5': { typical_or_guaranteed_value: '23 - 28', min_max_or_rejection_value: 'Min 22' },
        '6': { typical_or_guaranteed_value: '0.8', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: 'Min 1250', min_max_or_rejection_value: '-' }
      }
    },
    'RSA - 6000nar / 5700 min (RB2)': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 13' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '6000', min_max_or_rejection_value: 'Min 5700' },
        '4': { typical_or_guaranteed_value: '14 - 16', min_max_or_rejection_value: 'Max 17' },
        '5': { typical_or_guaranteed_value: '23 - 28', min_max_or_rejection_value: 'Min 21' },
        '6': { typical_or_guaranteed_value: '0.8', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: 'Min 1250', min_max_or_rejection_value: '-' }
      }
    },
    'USA - 6150nar ILB': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '11', min_max_or_rejection_value: '-' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '6150', min_max_or_rejection_value: 'Min 5900' },
        '4': { typical_or_guaranteed_value: '9', min_max_or_rejection_value: '-' },
        '5': { typical_or_guaranteed_value: '35', min_max_or_rejection_value: '-' },
        '6': { typical_or_guaranteed_value: '2.65', min_max_or_rejection_value: 'Max 3.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '55 approx', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'USA - Petcoke HS Generic': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Rejection' },
      options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '< 12', min_max_or_rejection_value: '' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '4': { typical_or_guaranteed_value: '< 1.0', min_max_or_rejection_value: '' },
        '5': { typical_or_guaranteed_value: '9 - 12', min_max_or_rejection_value: '' },
        '6': { typical_or_guaranteed_value: '< 6.5', min_max_or_rejection_value: '' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '9': { typical_or_guaranteed_value: '> 36', min_max_or_rejection_value: '' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'INDO - 5500gar GBU': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
      options: {
        '3': 'Gross Calorific Value(ARB)',
        '4': 'Ash(ADB)',
        '5': 'Volatile Matter(ADB)',
        '6': 'Sulfur(ADB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '24', min_max_or_rejection_value: '-' },
        '2': { typical_or_guaranteed_value: '10', min_max_or_rejection_value: '-' },
        '3': { typical_or_guaranteed_value: '5500', min_max_or_rejection_value: '5300' },
        '4': { typical_or_guaranteed_value: '5', min_max_or_rejection_value: '7.0 Max' },
        '5': { typical_or_guaranteed_value: '38 - 42', min_max_or_rejection_value: '-' },
        '6': { typical_or_guaranteed_value: '0.4', min_max_or_rejection_value: 'Max 1.0' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: 'Min 45', min_max_or_rejection_value: '' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'INDO - 4800gar IPC': {
      columnNames: { thirdColumn: 'Typical', fourthColumn: 'Rejection' },
      options: {
        '3': 'Gross Calorific Value(ARB)',
        '4': 'Ash(ADB)',
        '5': 'Volatile Matter(ADB)',
        '6': 'Sulfur(ADB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '29', min_max_or_rejection_value: 'Max 32' },
        '2': { typical_or_guaranteed_value: '15', min_max_or_rejection_value: '-' },
        '3': { typical_or_guaranteed_value: '4800', min_max_or_rejection_value: '4600' },
        '4': { typical_or_guaranteed_value: '6', min_max_or_rejection_value: '8.0 Max' },
        '5': { typical_or_guaranteed_value: '39', min_max_or_rejection_value: '-' },
        '6': { typical_or_guaranteed_value: '0.5', min_max_or_rejection_value: 'Max 0.7' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '42 approx', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
      }
    },
    'RSA - 5200nar (Osho Blend)': {
  columnNames: { thirdColumn: 'Typical', fourthColumn: 'Min/Max' },
  options: {
        '3': 'Net Calorific Value(ARB)',
        '4': 'ASH(ARB)',
        '5': 'Volatile Matter(ARB)',
        '6': 'Sulfur(ARB)'
      },
      values: {
        '1': { typical_or_guaranteed_value: '7 - 9', min_max_or_rejection_value: 'Max 12' },
        '2': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '3': { typical_or_guaranteed_value: '5200', min_max_or_rejection_value: '4900' },
        '4': { typical_or_guaranteed_value: '25', min_max_or_rejection_value: 'Max 28' },
        '5': { typical_or_guaranteed_value: '19', min_max_or_rejection_value: '-' },
        '6': { typical_or_guaranteed_value: '1.4', min_max_or_rejection_value: 'Max 1.6' },
        '7': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' },
        '8': { typical_or_guaranteed_value: '0 - 50', min_max_or_rejection_value: '-' },
        '9': { typical_or_guaranteed_value: '45 - 70', min_max_or_rejection_value: '-' },
        '10': { typical_or_guaranteed_value: '', min_max_or_rejection_value: '' }
  }
}
    // ... Add other presets here
  };

export const unitPresets = {
  1: '%',
  2: '%',
  3: 'kcal/kg',
  4: '%',
  5: '%',
  6: '%',
  7: '%',
  8: 'mm',
  9: '-',
  10: '°C'
};

export const qualityParametersPresets = [
  { description: 'Total Moisture(ARB)'},
  { description: 'Inherent Moisture(ADB)'},
  { description: 'Net Calorific Value(ARB)'},
  { description: 'ASH(ARB)'},
  { description: 'Volatile Matter(ARB)'},
  { description: 'Sulfur(ARB)'},
  { description: 'Fixed Carbon(ADB)'},
  { description: 'Sizing'},
  { description: 'HGI'},
  { description: 'AFT (IDT, red atm)'},
  // ... other parameters
];

